export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8364.e96d3c4e.jpg";